import {FormHelperText, Typography} from "@mui/material";
import {useState, useEffect} from "react";
import {connect} from "react-redux";
import TextField from "@mui/material/TextField";
import {handleUpdateOrderSubscription} from "../actions/ordersubscription";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import countryData from "../_dummydata/countryData.json";
import FormControl from "@mui/material/FormControl";
import {validateField} from "../utils/helpers";
export default connect(
  ({i18n, isLoading, orderSubscription}) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {handleUpdateOrderSubscription}
)((props) => {
  const {i18n, isLoading, orderSubscription} = props;
  const countries = countryData.countries;
  const [streetHouseNumber, setStreetHouseNumber] = useState(
    orderSubscription.streetHouseNumber
  );
  const [postcode, setPostCode] = useState(orderSubscription.zipCode);
  const [city, setCity] = useState(orderSubscription.city);
  const [addresssupplement, setAddressSupplement] = useState(
    orderSubscription.address
  );
  const [billEmail, setBillEmail] = useState(orderSubscription.invoiceEmail);
  const [companyName, setCompanyName] = useState(orderSubscription.companyName);
  const [land, setLand] = useState({
    label: orderSubscription?.country?.label
      ? orderSubscription?.country?.label
      : "",
    value: orderSubscription?.country?.value
      ? orderSubscription?.country?.value
      : "",
  });

  const [orderNumber, setOrderNumber] = useState(null);

  useEffect(() => {
    // Generate a random number between 10000 and 99999
    const randomNumber = Math.floor(Math.random() * 90000) + 10000;
    setOrderNumber(randomNumber);
  }, []);

  const [error, setError] = useState({
    companyName: false,
    streetHouseNumber: false,
    country: false,
    zipCode: false,
    city: false,
    address: false,
    invoiceEmail: false,
  });
  useEffect(() => {
    props.handleUpdateOrderSubscription({
      companyName,
      streetHouseNumber,
      country: {
        label: land.label,
        value: land.value,
      },
      zipCode: postcode,
      city,
      address: addresssupplement,
      invoiceEmail: billEmail,
      orderNumber,
    });
  }, [
    companyName,
    postcode,
    streetHouseNumber,
    city,
    land,
    addresssupplement,
    billEmail,
  ]);

  const handleChange = (event) => {
    setLand({
      label: event.target.value?.split("$")[1],
      value: event.target.value?.split("$")[0],
    });
    setError(event.target.value === "");
  };

  return (
    <>
      <FormControl>
        <div className="card-info">
          <Typography variant="h1">{i18n.abo_complete_title}</Typography>
          <Typography variant="h2">{i18n.billing_address_title}</Typography>
          <div className="billing-address">
            <div className="column">
              <div className="textField-row">
                <TextField
                  required
                  placeholder={i18n.companyName}
                  value={companyName}
                  onChange={(e) => {
                    setCompanyName(e.target.value);
                  }}
                  error={validateField(companyName)}
                  helperText={
                    validateField(companyName)
                      ? "Der Name des Unternehmens ist erforderlich"
                      : ""
                  }
                  FormHelperTextProps={{
                    className: "helper-text-margin",
                  }}
                />
                <TextField
                  placeholder={i18n.address_supplement}
                  value={addresssupplement}
                  onChange={(e) => setAddressSupplement(e.target.value)}
                />
              </div>
              <div className="textField-row">
                <TextField
                  required
                  placeholder={i18n.street_and_house_number}
                  value={streetHouseNumber}
                  onChange={(e) => {
                    setStreetHouseNumber(e.target.value);
                    setError(e.target.value === "");
                  }}
                  error={validateField(streetHouseNumber)}
                  helperText={
                    validateField(streetHouseNumber)
                      ? "Straße und Hausnummer sind erforderlich"
                      : ""
                  }
                  FormHelperTextProps={{
                    className: "helper-text-margin",
                  }}
                />
                <FormControl required>
                  <InputLabel id="country-select-label">Land</InputLabel>
                  <Select
                    required
                    labelId="country-select-label"
                    id="demo-simple-select"
                    value={land.value ? land.value + "$" + land.label : ""}
                    onChange={handleChange}
                    error={validateField(land.value)}
                    label="Land"
                  >
                    {Array.isArray(countries) &&
                      countries.map((selectedCountry) => (
                        <MenuItem
                          value={
                            selectedCountry.code + "$" + selectedCountry.country
                          }
                          key={
                            selectedCountry.code + "$" + selectedCountry.country
                          }
                        >
                          {selectedCountry.country}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText style={{color: "red"}}>
                    {validateField(land.value) ? "Land ist erforderlich" : ""}
                  </FormHelperText>
                </FormControl>
              </div>
              <div className="textField-row">
                <div className="addressField">
                  <div className="postcode-city-group">
                    <TextField
                      required
                      style={{width: "30%"}}
                      placeholder={i18n.post_code}
                      value={postcode}
                      onChange={(e) => {
                        setPostCode(e.target.value);
                        setError(e.target.value === "");
                      }}
                      error={validateField(postcode)}
                      helperText={
                        validateField(postcode) ? "PLZ ist erforderlich" : ""
                      }
                      FormHelperTextProps={{
                        className: "helper-text-margin",
                      }}
                    />
                    <TextField
                      required
                      style={{width: "70%"}}
                      placeholder={i18n.city}
                      value={city}
                      onChange={(e) => {
                        setCity(e.target.value);
                        setError(e.target.value === "");
                      }}
                      error={validateField(city)}
                      helperText={
                        validateField(city) ? "Ort ist erforderlich" : ""
                      }
                      FormHelperTextProps={{
                        className: "helper-text-margin",
                      }}
                    />
                  </div>
                  <TextField
                    className="email-field"
                    placeholder={i18n.emailEmail_for_invoicing}
                    value={billEmail}
                    onChange={(e) => setBillEmail(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </FormControl>
    </>
  );
});
